<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>{{ stepTitle }}</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <br />
  <div class="row expansion-panel">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h6>Saved Alerts</h6>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-table #table [dataSource]="alertsDataSource">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Alert Name</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="loadName">
          <mat-header-cell *matHeaderCellDef> Load Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngFor="let alertCondition of element.alertConditions">
              {{ alertCondition.logicOperator }} &nbsp;
              {{ alertCondition.load.name }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="parameter">
          <mat-header-cell *matHeaderCellDef>Parameter</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngFor="let alertCondition of element.alertConditions">
              {{ alertCondition.parameter }}
              {{ alertCondition.shiftwise?.shiftName }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="selectedCondition">
          <mat-header-cell *matHeaderCellDef
            >Selected Condition</mat-header-cell
          >
          <mat-cell *matCellDef="let element">
            <span *ngFor="let alertCondition of element.alertConditions">
              {{ alertCondition.conditionOperator | operatorsPipe }}&nbsp;{{
                alertCondition.conditionValue
              }}<br />
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="watchWindowFromTime">
          <mat-header-cell *matHeaderCellDef
            >Watch Window Start Time</mat-header-cell
          >
          <mat-cell *matCellDef="let element">
            <span *ngFor="let alertCondition of element.alertConditions">
              {{ alertCondition.watchWindowFromTime | date : 'hh:mm a' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="watchWindowToTime">
          <mat-header-cell *matHeaderCellDef
            >Watch Window End Time</mat-header-cell
          >
          <mat-cell *matCellDef="let element">
            <span *ngFor="let alertCondition of element.alertConditions">
              {{ alertCondition.watchWindowToTime | date : 'hh:mm a' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Alert Type</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngFor="let detail of element.alertNotificationDetails">
              {{ detail.type }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="frequency">
          <mat-header-cell *matHeaderCellDef>Alert Frequency</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngFor="let detail of element.alertNotificationDetails">
              {{ detail.frequency | frequenciesPipe }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="mailTo">
          <mat-header-cell *matHeaderCellDef>Mail To</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngFor="let mail of element.emailRecepientToList">
              {{ mail }}
            </span>
            <br />
            <span *ngFor="let mail of element.emailRecepientCcList">
              {{ mail }}
            </span>
            <br />
            <span *ngFor="let mail of element.emailRecepientBccList">
              {{ mail }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container
          matColumnDef="select"
          style="display: flex; justify-content: flex-end"
        >
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [(ngModel)]="checkedAll"
              (change)="checkAll()"
              #showButtons
            ></mat-checkbox>
            &nbsp; Active
          </mat-header-cell>
          <mat-cell *matCellDef="let element"
            ><mat-checkbox
              [inputId]="element.rId"
              [(ngModel)]="element.activate"
              [checked]="element.activate"
              [value]="element.activate"
              (change)="onAlertCheckedChange()"
              #showButtons
            ></mat-checkbox
          ></mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns"></mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]">
      </mat-paginator>
      <br />
      <div class="row">
        <!-- Button -->
        <div class="col-md-12" style="text-align: center">
          <button
            bciprimarybutton
            class="button-primary"
            id="actiavtebtn"
            (click)="saveActivationsChanges($event)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-checkmark-frame"
                style="width: max-content"
              ></mat-icon>
            </span>
            Save Activations Changes
          </button>
          &nbsp;
          <button
            bciprimarybutton
            class="button-primary"
            id="deactivatebtn"
            (click)="cancel($event)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-abort-frame"
                style="width: max-content"
              ></mat-icon>
            </span>
            Discard Activations Changes
          </button>
          &nbsp;
          <button
            bciprimarybutton
            class="button-primary"
            id="exportbtn"
            (click)="export($event)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-export"
                style="width: max-content"
              ></mat-icon>
            </span>
            Export Alerts
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
  <br />
  <div class="row expansion-panel">
    <mat-expansion-panel [expanded]="false" (opened)="onOpenEditAlert()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h6>Add or Edit Alert</h6>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <br />
      <form
        [formGroup]="formMasterGroup"
        #formDirective="ngForm"
        (ngSubmit)="submit()"
        novalidate
      >
        <div class="row">
          <div class="col-md-5" style="display: flex; align-items: center">
            <button
              bciprimarybutton
              class="button-primary"
              id="addnewAlertbtn"
              (click)="addNewAlert($event)"
              [disabled]="isDuplicatedAlert === true"
            >
              <span>
                <mat-icon
                  aria-hidden="false"
                  aria-label="add icon"
                  class="bosch-ic-add"
                  style="width: max-content"
                ></mat-icon>
              </span>
              Add New Alert
            </button>
          </div>
          <div class="col-md-7" style="display: flex; align-items: center">
            <div class="col-md-5">
              <mat-form-field>
                <mat-label>Select saved Alert</mat-label>
                <mat-select
                  [(ngModel)]="selectedAlertRId"
                  formControlName="selectedAlertRIdCtr"
                  [disabled]="origAlerts.length === 0"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <mat-option>--- Select saved Alert ---</mat-option>
                  <mat-option
                    *ngFor="let item of origAlerts"
                    [value]="item.alertId"
                    >{{ item.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-7">
              <button
                bciprimarybutton
                class="button-primary"
                id="editAlertbtn"
                [disabled]="
                  origAlerts.length === 0 ||
                  selectedAlertRId === undefined ||
                  selectedAlertRId === ''
                "
                (click)="editAlert($event, false)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-edit"
                    style="width: max-content"
                  ></mat-icon>
                </span>
                Edit Alert
              </button>
              &nbsp;
              <button
                bciprimarybutton
                class="button-primary"
                id="editAsNewAlertbtn"
                [disabled]="
                  origAlerts.length === 0 ||
                  selectedAlertRId === undefined ||
                  selectedAlertRId === ''
                "
                (click)="editAlert($event, true)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-edit"
                    style="width: max-content"
                  ></mat-icon>
                </span>
                Edit as new Alert
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <mat-label
                >Alerts Rule Name <span class="iep-required">*</span></mat-label
              >
              <mat-form-field>
                <input
                  [(ngModel)]="alert.name"
                  matInput
                  placeholder="Alert Name"
                  (ngModelChange)="checkExistedAlert()"
                  formControlName="alertNameCtr"
                  required
                />
                <mat-error *ngIf="isFieldHasError('alertNameCtr', 'required')"
                  >This field is required.</mat-error
                >
                <mat-error *ngIf="isFieldHasError('alertNameCtr', 'maxlength')">
                  Please provide name up to 50 Characters.
                </mat-error>
                <mat-error *ngIf="isFieldHasError('alertNameCtr', 'pattern')">
                  Only (& . - _ / : ,) special symbol allowed.
                </mat-error>
                <mat-error *ngIf="isFieldHasError('alertNameCtr', 'whitespace')"
                  >Please enter valid text.</mat-error
                >
                <mat-error
                  *ngIf="isFieldHasError('alertNameCtr', 'duplicated')"
                >
                  Duplicated Alert Name for site {{ siteId }}.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-5">
            <!-- ToFix#32 remove add button -->
            <div class="col-md-6">
              <div class="form-group">
                <mat-label
                  >Select Load: <span class="iep-required">*</span></mat-label
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <mat-label
                  >Select Parameter:
                  <span class="iep-required">*</span></mat-label
                >
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="col-md-8">
              <div class="form-group">
                <mat-label
                  >Select Condition and Value:
                  <span class="iep-required">*</span></mat-label
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <mat-label
                  >Watch Window: <span class="iep-required">*</span></mat-label
                >
              </div>
            </div>
          </div>
        </div>
        <hr />

        <ng-container
          formArrayName="alertConditionsItems"
          *ngFor="
            let alertCondition of alert.alertConditions;
            let $index = index
          "
        >
          <div class="row">
            <div [formGroupName]="$index">
              <div class="col-md-5">
                <!-- ToFix#32 remove add button -->
                <div class="col-md-6">
                  <mat-form-field style="width: 99%">
                    <mat-select
                      formControlName="loadCtr"
                      #loadSelect
                      [compareWith]="compareFnLoad"
                      [(ngModel)]="alert.alertConditions[$index].load"
                      (selectionChange)="changeLoad($event, $index)"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          (ngModelChange)="changeLoadFilter($event, $index)"
                          formControlName="loadSearchCtr"
                          [placeholderLabel]="'Select Load'"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let load of filteredLoads | async"
                        [value]="load"
                        >{{ load.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorinConditionsItems(
                          'loadCtr',
                          $index,
                          'required'
                        )
                      "
                      >Please Select Load</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-5">
                  <mat-form-field style="width: 90%">
                    <mat-select
                      formControlName="parameterCtr"
                      [disabled]="
                        alert.alertConditions[$index].load === undefined
                      "
                      [(ngModel)]="alert.alertConditions[$index].parameter"
                      (selectionChange)="checkIfDigitalParam($event, $index)"
                    >
                      <mat-option [value]="noData">No data received</mat-option>
                      <mat-option
                        *ngFor="
                          let param of alert.alertConditions[$index].load
                            ?.paramArr
                        "
                        [value]="param.value ? param.value : param"
                      >
                        {{ param.text ? param.text : param }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorinConditionsItems(
                          'parameterCtr',
                          $index,
                          'required'
                        )
                      "
                      >Please Select Param(s)</mat-error
                    >
                  </mat-form-field>
                  <br />
                  <mat-form-field
                    *ngIf="
                      alert.alertConditions[$index].parameter ===
                      'Shiftwaise Energy'
                    "
                  >
                    <mat-label>Select Shift Name</mat-label>
                    <mat-select
                      formControlName="shiftwiseCtr"
                      [(ngModel)]="alert.alertConditions[$index].shiftwise"
                      (ngModelChange)="setAlertContent()"
                    >
                      <mat-option
                        *ngFor="let item of shifts"
                        [value]="item.shiftName"
                        >{{ item.shiftName }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorinConditionsItems(
                          'shiftwiseCtr',
                          $index,
                          'required'
                        )
                      "
                      >Please Select Shift Name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-7">
                <div class="col-md-7">
                  <div class="col-md-7">
                    <mat-form-field style="width: 90%">
                      <mat-label>Select Operator</mat-label>
                      <mat-select
                        [(ngModel)]="
                          alert.alertConditions[$index].conditionOperator
                        "
                        (ngModelChange)="setAlertContent()"
                        formControlName="conditionOperatorCtr"
                      >
                        <mat-option
                          *ngFor="let item of operators"
                          [value]="item.value"
                          >{{ item.text }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinConditionsItems(
                            'conditionOperatorCtr',
                            $index,
                            'required'
                          )
                        "
                        >Please Select Operator</mat-error
                      >
                    </mat-form-field>
                  </div>
                  <div class="col-md-5">
                    <mat-form-field
                      *ngIf="!showDigitalValueMap[$index]"
                      style="width: 90%"
                    >
                      <input
                        matInput
                        type="text"
                        (ngModelChange)="setAlertContent()"
                        [(ngModel)]="
                          alert.alertConditions[$index].conditionValue
                        "
                        formControlName="conditionValueCtr"
                        placeholder="Select Value"
                        pattern="[0-9]*"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinConditionsItems(
                            'conditionValueCtr',
                            $index,
                            'required'
                          )
                        "
                        >This field is required.</mat-error
                      >
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinConditionsItems(
                            'conditionValueCtr',
                            $index,
                            'pattern'
                          )
                        "
                        >only numbers are allowed</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="showDigitalValueMap[$index]"
                      style="width: 90%"
                    >
                      <mat-label>Select Value</mat-label>
                      <mat-select
                        [(ngModel)]="
                          alert.alertConditions[$index].conditionValue
                        "
                        (ngModelChange)="setAlertContent()"
                        formControlName="conditionOperatorCtr"
                      >
                        <mat-option
                          *ngFor="
                            let item of alert.alertConditions[$index].load
                              ?.digitalIOMap[
                              alert.alertConditions[$index].parameter
                            ]
                          "
                          [value]="item"
                          >{{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinConditionsItems(
                            'conditionValueCtr',
                            $index,
                            'required'
                          )
                        "
                        >Please Select Value</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="row" style="display: flex; align-items: center">
                    <div class="col-md-6">
                      <mat-form-field style="width: 100%">
                        <input
                          matInput
                          type="time"
                          formControlName="watchWindowFromTimeCtr"
                          [(ngModel)]="
                            alert.alertConditions[$index].watchWindowFromTime
                          "
                          placeholder="From Time (HH:mm)"
                          required
                        />
                        <mat-error
                          *ngIf="
                            isFieldHasErrorinConditionsItems(
                              'watchWindowFromTimeCtr',
                              $index,
                              'required'
                            )
                          "
                          >This field is required.</mat-error
                        >
                        <mat-error
                          *ngIf="
                            isFieldHasErrorinConditionsItems(
                              'watchWindowFromTimeCtr',
                              $index,
                              'time'
                            )
                          "
                        >
                          From time should be less than to time
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div
                      class="col-md-1"
                      style="display: flex; align-items: center"
                    >
                      <mat-label>To</mat-label>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field style="width: 100%">
                        <input
                          matInput
                          type="time"
                          formControlName="watchWindowToTimeCtr"
                          [(ngModel)]="
                            alert.alertConditions[$index].watchWindowToTime
                          "
                          placeholder="To Time (HH:mm)"
                          required
                        />
                        <mat-error
                          *ngIf="
                            isFieldHasErrorinConditionsItems(
                              'watchWindowToTimeCtr',
                              $index,
                              'required'
                            )
                          "
                          >This field is required.</mat-error
                        >
                        <mat-error
                          *ngIf="
                            isFieldHasErrorinConditionsItems(
                              'watchWindowToTimeCtr',
                              $index,
                              'time'
                            )
                          "
                        >
                          To time should be greater than from time
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" style="display: flex; flex-wrap: wrap">
                    <div
                      formArrayName="watchWindowOnDaysArray"
                      *ngFor="
                        let item of alert.alertConditions[$index]
                          .watchWindowOnDays;
                        let $dayIndex = index
                      "
                    >
                      <div [formGroupName]="$dayIndex">
                        <mat-checkbox
                          name="{{ $index }}-{{ $dayIndex }}"
                          id="{{ $index }}-{{ $dayIndex }}"
                          (change)="changeChkBoxDays($event, $index, $dayIndex)"
                          formControlName="dayOnWatchWindowCtr_{{ $dayIndex }}"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          {{ item.text }}</mat-checkbox
                        >
                        &nbsp; &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </ng-container>

        <div class="row">
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input"
                >Confirmed Presence Count: <span class="iep-required">*</span>
                <mat-icon
                  aria-hidden="false"
                  aria-label="weather icon"
                  class="Bosch-Ic-information"
                  style="width: max-content"
                  matTooltip="Confirmed Presence Count &#013; Alert will be confirmed"
                ></mat-icon>
              </mat-label>
            </div>
            <div class="col-md-7">
              <mat-form-field>
                <input
                  type="number"
                  [(ngModel)]="alert.confirmedPresenceSampleCount"
                  matInput
                  placeholder="Confirmed Presence Count"
                  formControlName="confirmedPresenceSampleCountCtr"
                  required
                />
                <mat-error
                  *ngIf="
                    isFieldHasError(
                      'confirmedPresenceSampleCountCtr',
                      'required'
                    )
                  "
                  >This field is required.</mat-error
                >
                <mat-error
                  *ngIf="
                    isFieldHasError('confirmedPresenceSampleCountCtr', 'min') ||
                    isFieldHasError('confirmedPresenceSampleCountCtr', 'max')
                  "
                >
                  Confirmed Presence Count is greater than 0 and less than or
                  equal to 90.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input"
                >Confirmed Absense Count:
                <mat-icon
                  aria-hidden="false"
                  aria-label="weather icon"
                  class="Bosch-Ic-information"
                  style="width: max-content"
                  matTooltip="Confirmed Absense Count &#013; Alert to be triggered after"
                ></mat-icon>
              </mat-label>
            </div>
            <div class="col-md-7">
              <mat-form-field>
                <input
                  type="text"
                  [(ngModel)]="alert.confirmedAbsenceSampleCount"
                  matInput
                  placeholder="Confirmed Absense Count"
                  formControlName="confirmedAbsenceSampleCountCtr"
                />
                <mat-error
                  *ngIf="
                    isFieldHasError('confirmedAbsenceSampleCountCtr', 'pattern')
                  "
                >
                  Only numbers are allowed.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input"
                >Alert For Type: <span class="iep-required">*</span>
              </mat-label>
            </div>
            <div class="col-md-7">
              <mat-form-field>
                <mat-label>Select Alert For Type</mat-label>
                <mat-select
                  [(ngModel)]="alert.alertForType"
                  formControlName="alertForTypeCtr"
                  required
                >
                  <mat-option
                    *ngFor="let item of alertForTypes"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>
                <mat-error
                  *ngIf="isFieldHasError('alertForTypeCtr', 'required')"
                  >Please Alert For Type</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" style="display: flex; align-items: flex-end">
            <div class="col-md-5">
              <mat-label class="label-input"
                >Alert Type and Frequency: <span class="iep-required">*</span>
              </mat-label>
            </div>
            <div class="col-md-7">
              <mat-checkbox
                [(ngModel)]="alertTypeAll"
                (change)="checkAllAlertType()"
                [ngModelOptions]="{ standalone: true }"
              >
                Select All</mat-checkbox
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">&nbsp;</div>
          <div class="col-md-10 custom-align-col">
            <div
              fxLayout="row wrap"
              fxLayout.xs="column"
              style="display: flex; width: 100%"
            >
              <ng-container *ngFor="let item of alertTypes; let $index = index">
                <div
                  fxFlex="33%;"
                  fxFlex.xs="50%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="
                    display: flex;
                    align-items: baseline;
                    flex: 1 1 33%;
                    width: 33%;
                  "
                >
                  <mat-checkbox
                    [(ngModel)]="
                      alert.alertNotificationDetails[$index].type.selected
                    "
                    (change)="changeChkBoxAlertType($index)"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    {{ item.text }}</mat-checkbox
                  >
                  <span style="margin-right: 25px"></span>
                  <mat-form-field>
                    <mat-label>Select Frequency</mat-label>
                    <mat-select
                      [(ngModel)]="
                        alert.alertNotificationDetails[$index].frequency
                      "
                      [ngModelOptions]="{ standalone: true }"
                      formControlName="alertNotificationFrequencyCtr_{{
                        $index
                      }}"
                      required
                    >
                      <mat-option
                        *ngFor="let item of frequencies"
                        [value]="item.value"
                        >{{ item.text }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'alertNotificationFrequencyCtr_' + $index,
                          'required'
                        )
                      "
                      >Please Select Frequency</mat-error
                    >
                  </mat-form-field>
                  <span style="margin-right: 30px"></span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input"
                >Alert Criticality: <span class="iep-required">*</span>
              </mat-label>
            </div>
            <div class="col-md-7">
              <mat-form-field>
                <mat-label>Select Level</mat-label>
                <mat-select
                  [(ngModel)]="alert.criticalityLevel"
                  (ngModelChange)="setAlertContent()"
                  formControlName="criticalityLevelCtr"
                >
                  <mat-option
                    *ngFor="let item of criticalityLevel"
                    [value]="item"
                    >{{ item }}</mat-option
                  >
                </mat-select>
                <mat-error
                  *ngIf="isFieldHasError('criticalityLevelCtr', 'required')"
                  >Select Level</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input">Content of the Alert: </mat-label>
            </div>
            <div class="col-md-7" style="display: flex; align-items: baseline">
              <section
                class="example-section"
                *ngFor="let item of alertContentTypes"
              >
                <input
                  [ngModelOptions]="{ standalone: true }"
                  type="radio"
                  [(ngModel)]="form.alertContentType"
                  name="alertContentName"
                  value="{{ item.value }}"
                  checked="form.alertContentType == 'default'"
                  (ngModelChange)="onAlertContentTypeChange()"
                />
                <mat-label class="example-margin">
                  &nbsp; {{ item.text }}</mat-label
                >
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">&nbsp;</div>
          <div class="col-md-10 custom-align-col">
            <mat-form-field style="width: 100%">
              <textarea
                [(ngModel)]="alertContent"
                matInput
                [disabled]="form.alertContentType !== 'custom'"
                formControlName="alertContentCtr"
              ></textarea>
              <mat-error
                *ngIf="isFieldHasError('alertContentCtr', 'whitespace')"
                >Please enter valid text.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="row" style="display: flex; align-items: flex-end">
          <div class="col-md-2">
            <mat-label class="label-input">Send this Alert to: </mat-label>
          </div>
          <div class="col-md-10 custom-align-col">
            <div
              fxLayout="row"
              fxLayout.xs="column"
              style="display: flex; width: 100%"
            >
              <div
                fxFlex="20%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="display: flex; flex: 1 1 20%; align-items: baseline"
              >
                <mat-checkbox
                  [(ngModel)]="alertLevelAll"
                  (change)="checkAllAlertLevel()"
                  [ngModelOptions]="{ standalone: true }"
                >
                  Select All</mat-checkbox
                >
              </div>
              <ng-container
                *ngFor="let item of alert.alertLevels; let $index = index"
              >
                <div
                  fxFlex="20%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="display: flex; flex: 1 1 20%; align-items: baseline"
                >
                  <mat-checkbox
                    [(ngModel)]="alert.alertLevels[$index].selected"
                    (change)="checkForAllAlertLevel()"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    {{ item.text }}</mat-checkbox
                  >
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <br />
        <div class="row" style="display: flex">
          <div class="col-md-2"></div>
          <div class="col-md-10 custom-align-col">
            <div
              fxLayout="row"
              fxLayout.xs="column"
              style="display: flex; width: 100%"
            >
              <div
                fxFlex="30%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="display: flex; flex: 1 1 30%; align-items: baseline"
              >
                <mat-label class="label-input">Email To List: </mat-label>
                <mat-form-field style="display: flex; width: 80%">
                  <mat-label>--- Select Receipients ---</mat-label>
                  <mat-select
                    multiple
                    [(ngModel)]="alert.emailRecepientToList"
                    formControlName="emailRecepientToListCtr"
                  >
                    <mat-option *ngFor="let item of emailList" [value]="item">{{
                      item
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                fxFlex="30%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="display: flex; flex: 1 1 30%; align-items: baseline"
              >
                <mat-label class="label-input">Email CC List: </mat-label>
                <span style="margin-right: 20px"></span>
                <mat-form-field style="width: 80%">
                  <mat-label>--- Select Receipients ---</mat-label>
                  <mat-select
                    multiple
                    [(ngModel)]="alert.emailRecepientCcList"
                    formControlName="emailRecepientCcListCtr"
                  >
                    <mat-option *ngFor="let item of emailList" [value]="item">{{
                      item
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <span style="margin-right: 20px"></span>
              </div>
              <div
                fxFlex="30%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="display: flex; flex: 1 1 30%; align-items: baseline"
              >
                <mat-label class="label-input">Email BCC List: </mat-label>
                <span style="margin-right: 20px"></span>
                <mat-form-field style="width: 80%">
                  <mat-label>--- Select Receipients ---</mat-label>
                  <mat-select
                    multiple
                    [(ngModel)]="alert.emailRecepientBccList"
                    formControlName="emailRecepientBccListCtr"
                  >
                    <mat-option *ngFor="let item of emailList" [value]="item">{{
                      item
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="display: flex; align-items: baseline">
          <div class="col-md-2">
            <mat-label class="label-input"
              >Alerts Send Window: <span class="iep-required">*</span>
            </mat-label>
          </div>
          <div class="col-md-10 custom-align-col">
            <div
              fxLayout="row"
              fxLayout.xs="column"
              style="display: flex; width: 100%"
            >
              <div
                fxFlex="25%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="
                  display: flex;
                  flex: 1 1 25%;
                  align-items: baseline;
                  width: 18%;
                "
              >
                <mat-form-field>
                  <input
                    matInput
                    type="time"
                    formControlName="sendWindowFromTimeCtr"
                    [(ngModel)]="alert.sendWindowFromTime"
                    placeholder="From Time (HH:mm:ss.zzz)"
                    required
                  />
                  <mat-error
                    *ngIf="isFieldHasError('sendWindowFromTimeCtr', 'required')"
                    >This field is required.</mat-error
                  >
                  <mat-error
                    *ngIf="isFieldHasError('sendWindowFromTimeCtr', 'stime')"
                  >
                    From time should be less than to time
                  </mat-error>
                </mat-form-field>
              </div>
              <div
                fxFlex="5%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="display: flex; flex: 1 1 5%; align-items: baseline"
              >
                <mat-label class="label-input">To </mat-label>
              </div>
              <div
                fxFlex="25%;"
                fxFlex.xs="80%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="
                  display: flex;
                  flex: 1 1 25%;
                  align-items: baseline;
                  width: 18%;
                "
              >
                <mat-form-field>
                  <input
                    matInput
                    type="time"
                    formControlName="sendWindowToTimeCtr"
                    [(ngModel)]="alert.sendWindowToTime"
                    placeholder="To Time (HH:mm:ss.zzz)"
                    required
                  />
                  <mat-error
                    *ngIf="isFieldHasError('sendWindowToTimeCtr', 'required')"
                    >This field is required.</mat-error
                  >
                  <mat-error
                    *ngIf="isFieldHasError('sendWindowToTimeCtr', 'stime')"
                    >To time should be greater than from time</mat-error
                  >
                </mat-form-field>
              </div>
              <div
                fxFlex="45%;"
                fxFlex.xs="10%"
                fxLayout="row wrap"
                fxLayout.xs="column"
                style="display: flex; flex: 1 1 45%; align-items: baseline"
              >
                <ng-container
                  *ngFor="let item of customDays; let $index = index"
                >
                  <mat-checkbox
                    [(ngModel)]="alert.sendWindowOnDays[$index].selected"
                    formControlName="sendWindowOnDayCtr_{{ $index }}"
                    name="{{ $index }}-sendWindowOnDays"
                    id="{{ $index }}-sendWindowOnDays"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    {{ item.text }}</mat-checkbox
                  >
                  <span style="margin-right: 10px"></span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input"
                >Activate Alert now:<span class="iep-required">*</span>
              </mat-label>
            </div>
            <div class="col-md-7" style="display: flex; align-items: baseline">
              <section class="example-section">
                <input
                  [ngModelOptions]="{ standalone: true }"
                  type="radio"
                  id="activateAlert"
                  [(ngModel)]="alert.activate"
                  name="alertActivation"
                  value="true"
                  id="alertActivation-0"
                />
                <mat-label class="example-margin"> &nbsp; Yes</mat-label>
              </section>
              <section class="example-section">
                <input
                  [ngModelOptions]="{ standalone: true }"
                  type="radio"
                  id="deActivateAlert"
                  [(ngModel)]="alert.activate"
                  name="alertActivation"
                  value="false"
                  id="alertActivation-1"
                />
                <mat-label class="example-margin"> &nbsp; No</mat-label>
              </section>
            </div>
          </div>
        </div>
        <br />
        <!-- Button -->
        <div class="col-md-12" style="text-align: center">
          <button
            bciprimarybutton
            class="button-primary"
            id="saveAlertbtn"
            type="submit"
            bciprimarybutton
            [disabled]="!formMasterGroup.valid"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-checkmark-frame"
                style="width: max-content"
              ></mat-icon>
            </span>
            Save Alert
          </button>
          &nbsp;
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-5">
              <mat-label class="label-input" style="font-weight: bold">
                <mat-icon
                  aria-hidden="false"
                  aria-label="link icon"
                  class="bosch-ic-link"
                  style="width: max-content"
                ></mat-icon>
                &nbsp; Link to MIS Report?
              </mat-label>
            </div>
            <div class="col-md-7" style="display: flex; align-items: baseline">
              <section class="example-section">
                <input
                  [ngModelOptions]="{ standalone: true }"
                  id="alertToMIS"
                  type="radio"
                  [(ngModel)]="AlertToMISReport"
                  (ngModelChange)="onAlertToMISReportChange()"
                  name="AlertToMIS"
                  value="yes"
                />
                <mat-label class="example-margin"> &nbsp; Yes</mat-label>
              </section>
              <section class="example-section">
                <input
                  [ngModelOptions]="{ standalone: true }"
                  id="noLinkAlertToMIS"
                  type="radio"
                  [(ngModel)]="AlertToMISReport"
                  (ngModelChange)="onAlertToMISReportChange()"
                  name="AlertToMIS"
                  value="no"
                />
                <mat-label class="example-margin"> &nbsp; No</mat-label>
              </section>
            </div>
          </div>
        </div>
      </form>
      <form [formGroup]="formMisGroup" (ngSubmit)="saveMISDetails()" novalidate>
        <ng-container *ngIf="AlertToMISReport === 'yes'">
          <div class="row">
            <div class="col-md-12">
              <mat-label class="label-input" style="font-weight: bold"
                >MIS Report Details:</mat-label
              >
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-8">
              <div class="col-md-5">
                <mat-label class="label-input"
                  >Create New Service: <span class="iep-required">*</span>
                </mat-label>
              </div>
              <div
                class="col-md-7"
                style="display: flex; align-items: baseline"
              >
                <mat-form-field>
                  <input
                    matInput
                    formControlName="newServiceCtr"
                    [(ngModel)]="alert.newService"
                  />
                </mat-form-field>
                &nbsp;
                <button
                  id="createMISbtn"
                  bciprimarybutton
                  class="button-primary"
                  (click)="createNewService($event)"
                  [disabled]="
                    alert.newService === undefined ||
                    alert.newService === null ||
                    alert.newService === ''
                  "
                >
                  <span>
                    <mat-icon
                      aria-hidden="false"
                      aria-label="weather icon"
                      class="bosch-ic-checkmark-frame"
                      style="width: max-content"
                    ></mat-icon>
                  </span>
                  Create Service
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="col-md-5">
                <mat-label class="label-input">Logo: </mat-label>
              </div>
              <div
                class="col-md-7"
                style="display: flex; align-items: baseline"
              >
                <input
                  type="file"
                  id="uploadMisServiceLogo"
                  (change)="uploadDocument($event, 'misServiceLogo')"
                  class="hidden"
                  accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
                />
                <button
                  type="button"
                  id="attachmentbtn"
                  [disabled]="isReadOnly"
                  matTooltip="Select logo picture"
                  (click)="selectDocument('uploadMisServiceLogo')"
                >
                  <mat-icon
                    aria-hidden="false"
                    aria-label="icon"
                    class="bosch-ic-paperclip mat-icon Bosch-Ic"
                    style="width: max-content"
                  ></mat-icon>
                </button>
                {{ logoAttachment.name }} <br />
              </div>
            </div>
          </div>
          <div class="row" style="display: flex">
            <div class="col-md-2"></div>
            <div class="col-md-10 custom-align-col">
              <div fxLayout="row wrap" fxLayout.xs="column" style="width: 100%">
                <div
                  fxFlex="30%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="align-items: baseline; flex: 1 1 30%; width: 30%"
                >
                  <mat-label class="label-input"
                    >Enabled Alerts: <span class="iep-required">*</span>
                  </mat-label>
                  <mat-form-field style="width: 80%">
                    <mat-label>--- Select Alert ---</mat-label>
                    <mat-select
                      multiple
                      [(ngModel)]="alert.enabledAlert"
                      formControlName="enabledAlertCtr"
                    >
                      <mat-option
                        *ngFor="let item of activeAlertsList"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorInFormMisGroup(
                          'enabledAlertCtr',
                          'required'
                        )
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                </div>
                <div
                  fxFlex="30%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="align-items: baseline; flex: 1 1 30%; width: 30%"
                >
                  <mat-label class="label-input"
                    >Service to link Alert: <span class="iep-required">*</span>
                  </mat-label>
                  <span style="margin-right: 20px"></span>
                  <mat-form-field style="width: 80%">
                    <mat-label>--- Select Alert ---</mat-label>
                    <mat-select
                      [(ngModel)]="alert.misService"
                      formControlName="misServiceCtr"
                    >
                      <mat-option
                        *ngFor="let item of misServiceList"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorInFormMisGroup(
                          'misServiceCtr',
                          'required'
                        )
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                  <span style="margin-right: 20px"></span>
                </div>
                <div
                  fxFlex="30%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="align-items: baseline; flex: 1 1 30%; width: 30%"
                >
                  <mat-label class="label-input"
                    >Criticality Levels: <span class="iep-required">*</span>
                  </mat-label>
                  <span style="margin-right: 20px"></span>
                  <mat-form-field style="width: 80%">
                    <mat-label>---- Select Criticality Level -----</mat-label>
                    <mat-select
                      [(ngModel)]="alert.criticalityMisLevel"
                      formControlName="criticalityMisLevelCtr"
                    >
                      <mat-option
                        *ngFor="let item of criticalityLevel"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorInFormMisGroup(
                          'criticalityMisLevelCtr',
                          'required'
                        )
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="display: flex">
            <div class="col-md-2"></div>
            <div class="col-md-10 custom-align-col">
              <div fxLayout="row wrap" fxLayout.xs="column" style="width: 100%">
                <div
                  fxFlex="30%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="align-items: baseline; flex: 1 1 30%; width: 30%"
                >
                  <mat-label class="label-input"
                    >Cost:
                    <span class="iep-required"
                      >*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                    >
                  </mat-label>
                  <span style="margin-right: 20px"></span>
                  <mat-form-field style="width: 80%">
                    <input
                      matInput
                      formControlName="costCtr"
                      [(ngModel)]="alert.cost"
                      required
                    />
                    <mat-error
                      *ngIf="
                        isFieldHasErrorInFormMisGroup('costCtr', 'required')
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                  <span style="margin-right: 20px"></span>
                </div>
                <div
                  fxFlex="30%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="align-items: baseline; flex: 1 1 30%; width: 30%"
                >
                  <mat-label class="label-input"
                    >Currency: <span class="iep-required">*</span>
                  </mat-label>
                  <span style="margin-right: 20px"></span>
                  <mat-form-field style="width: 80%">
                    <mat-label>--- Select Currency ---</mat-label>
                    <mat-select
                      [(ngModel)]="alert.currency"
                      formControlName="currencyCtr"
                      required
                    >
                      <mat-option
                        *ngFor="let item of currencies"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorInFormMisGroup('currencyCtr', 'required')
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                  <span style="margin-right: 20px"></span>
                </div>
                <div
                  fxFlex="30%;"
                  fxFlex.xs="80%"
                  fxLayout="row wrap"
                  fxLayout.xs="column"
                  style="align-items: baseline; flex: 1 1 30%; width: 30%"
                ></div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="col-md-5">
                <mat-label class="label-input" style="font-weight: bold">
                  <mat-icon
                    aria-hidden="false"
                    aria-label="link icon"
                    class="bosch-ic-list-view"
                    style="width: max-content"
                  ></mat-icon>
                  &nbsp; Show Service On DashBoard?
                </mat-label>
              </div>
              <div
                class="col-md-7"
                style="display: flex; align-items: baseline"
              >
                <section class="example-section">
                  <input
                    [ngModelOptions]="{ standalone: true }"
                    type="radio"
                    [(ngModel)]="alert.displayOnPortal"
                    (ngModelChange)="onDisplayOnPortalChange()"
                    name="servicesToDisplay"
                    value="true"
                  />
                  <mat-label class="example-margin"> &nbsp; Yes</mat-label>
                </section>
                <section class="example-section">
                  <input
                    [ngModelOptions]="{ standalone: true }"
                    type="radio"
                    [(ngModel)]="alert.displayOnPortal"
                    (ngModelChange)="onDisplayOnPortalChange()"
                    name="servicesToDisplay"
                    value="false"
                    checked
                  />
                  <mat-label class="example-margin"> &nbsp; No</mat-label>
                </section>
              </div>
            </div>
          </div>
          <ng-container *ngIf="alert.displayOnPortal === 'true'">
            <div class="row">
              <div class="col-md-12">
                <mat-label class="label-input" style="font-weight: bold"
                  >Select Service And Set Target:</mat-label
                ><br />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <div
                  class="row"
                  *ngFor="let item of alert.columnsOnPortal; let $index = index"
                  style="display: flex; align-items: baseline"
                >
                  <div
                    class="col-md-2"
                    style="display: flex; align-items: flex-end"
                  >
                    <mat-checkbox
                      [(ngModel)]="alert.columnsOnPortal[$index].selected"
                      (change)="onColumnsOnPortalChange($event, $index)"
                      [ngModelOptions]="{ standalone: true }"
                    >
                      &nbsp; {{ item.text }}</mat-checkbox
                    >
                  </div>
                  <div class="col-md-4">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="columnsOnPortalCtr_{{ $index }}"
                        [(ngModel)]="alert.columnsOnPortal[$index].textValue"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="col-md-5">
                  <mat-label class="label-input"
                    >Target Duration duration:
                    <span class="iep-required">*</span>
                  </mat-label>
                </div>
                <div
                  class="col-md-7"
                  style="display: flex; align-items: baseline"
                >
                  <mat-form-field style="width: 100%">
                    <mat-label>---- Select Target Duration -----</mat-label>
                    <mat-select formControlName="targetDurationCtr" required>
                      <mat-option
                        *ngFor="let item of targetDuration"
                        [value]="item"
                        >{{ item }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasErrorInFormMisGroup(
                          'targetDurationCtr',
                          'required'
                        )
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>
          <br />
          <!-- Button -->
          <div class="row">
            <div class="col-md-12" style="text-align: center">
              <button
                bciprimarybutton
                class="button-primary"
                type="submit"
                [disabled]="!formMisGroup.valid"
                id="saveMISbtn"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="weather icon"
                    class="bosch-ic-checkmark-frame"
                    style="width: max-content"
                  ></mat-icon>
                </span>
                Save
              </button>
            </div>
          </div>
        </ng-container>
      </form>
    </mat-expansion-panel>
  </div>
  <br />
  <div class="row">
    <div class="col-md-12" style="text-align: center">
      <button
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
        (click)="goPrevious($event)"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      &nbsp;
      <button
        id="nextbtn"
        bciprimarybutton
        class="button-primary"
        (click)="goTo($event)"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </div>
</mat-expansion-panel>
